"use client";

import {
  ColumnDef,
  ExpandedState,
  flexRender,
  getCoreRowModel,
  getExpandedRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { t } from "i18next";

import React, { useEffect, useState } from "react";
import { ScrollArea } from "../ScrollArea/ScrollArea";
import { TableCell, TableRow } from "../Table/Table";
import { Separator } from "../Separator";

interface DataTableProps<TData, TValue> {
  columns: ColumnDef<TData, TValue>[];
  data: TData[];
  onClickRow?: (item: TData) => void;
}



export function SimpleDataTable<TData, TValue>({
  columns,
  data,
  onClickRow
}: DataTableProps<TData, TValue>) {
  const [expanded, setExpanded] = React.useState<ExpandedState>({});

  const table = useReactTable({
    data,
    columns,
    state: {
      expanded,
    },
    onExpandedChange: setExpanded,
    //@ts-ignore
    getSubRows: (row) => row.subRows, // Выбор свойства объекта, где находятся дочерние элементы дерева
    getCoreRowModel: getCoreRowModel(),
    getExpandedRowModel: getExpandedRowModel(),
  });

  useEffect(() => {
    table.toggleAllRowsExpanded();
  }, []);

  function onSelectRow(item: TData) {
    onClickRow?.(item)
  }

  return (
    <>
      {table.getHeaderGroups().map((headerGroup) => (
        <div key={headerGroup.id} className="flex px-6 pt-3">
          {headerGroup.headers.map((header) => {
            return (
              <div key={header.id} className={`${header.getSize() === 1000 ? "grow flex" : "flex flex-none w-[" + header.getSize() + "px]"} h-6 text-sm font-medium`}>
                <div className={`${"min-w-[" + header.getSize() + "px]"}`}>{header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}</div>
              </div>
            );
          })}
        </div>
      ))}    
      <div className="px-6">
        <Separator/>
      </div>
      <ScrollArea>
        {table.getRowModel().rows?.length ? (
          table.getRowModel().rows.map((row) => (
            <div
              className={`cursor-pointer flex w-full px-6 hover:bg-muted`}
              key={row.id}
              data-state={row.getIsSelected() && "selected"}
              onClick={() => onSelectRow(row.original)}
            >
              {row.getVisibleCells().map((cell) => (
                <div
                  key={cell.id}
                  className={`${cell.column.columnDef.size === 1000 ? "grow flex" : "flex flex-none w-[" + cell.column.columnDef.size + "px]"} min-h-12 h-12 items-center text-sm`}
                >
                  <div className={`min-w-[${cell.column.columnDef.minSize}px]`}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</div>
                </div>
              ))}
            </div>
          ))
        ) : (
          <TableRow>
            <TableCell colSpan={columns.length} className="h-24 text-center">
              {t("no_data")}
            </TableCell>
          </TableRow>
        )}
      </ScrollArea>
    </>
  );
}
